import pb from '@libs/pocketbase';

export const authApi = {
  async requestPasswordReset(email: string): Promise<void> {
    await pb.collection('users').requestPasswordReset(email);
  },

  async confirmPasswordReset(token: string, password: string, confirmPassword: string): Promise<void> {
    await pb.collection('users').confirmPasswordReset(token, password, confirmPassword);
  },
};

